<div class="circle-border">
  <div class="circle-bg">
    <tidy-ai-loader [colored]="true" />
  </div>
</div>
